/** @format */

export default {
	setProducts( products, count, query ) {
		return {
			type: 'SET_PRODUCTS',
			products,
			count,
			query: query || {},
		};
	},
	setProductsError( query ) {
		return {
			type: 'SET_PRODUCTS_ERROR',
			query: query || {},
		};
	},
	fetchProductsFromAPI( path ) {
		return {
			type: 'FETCH_PRODUCTS_FROM_API',
			path: path.path,
		};
	},
};
